export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['User Management']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Organizations',
        to: '/orgs',
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Users',
        to: '/users',
        icon: 'cil-user'
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'UserProfile',
      //   to: '/user-profile',
      //   icon: 'cil-drop'
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Roles',
        to: '/roles',
        icon: 'cil-shield-alt'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Polygon Management']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Ports',
        to: '/ports',
        icon: 'cil-globe-alt'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Machine Learning',
        to: '/ml',
        icon: 'cil-globe-alt'
      },
    ]
  }
]